import React, { useState } from "react";
import { X } from "lucide-react";
import BackTop from "../landing/BackTop";
import ChatPanel from "./ChatPanel";
import useNexoChat from "./useNexoChat";

const ChatBubble = () => {
  const [open, setOpen] = useState(false);
  const {
    messages,
    sending,
    error,
    conversationClosed,
    showWhatsappHandoff,
    sendMessage,
    retry,
    resetConversation,
  } = useNexoChat();

  return (
    <>
      <BackTop />
      {open && (
        <ChatPanel
          onClose={() => setOpen(false)}
          messages={messages}
          sending={sending}
          error={error}
          conversationClosed={conversationClosed}
          showWhatsappHandoff={showWhatsappHandoff}
          sendMessage={sendMessage}
          retry={retry}
          resetConversation={resetConversation}
        />
      )}
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="nexo-chat-bubble"
        aria-label={open ? "Cerrar chat de NEXO" : "Abrir chat de NEXO"}
        aria-expanded={open}
        className="fixed z-40 grid place-items-center w-14 h-14 rounded-full text-white transition-transform hover:scale-110"
        style={{
          right: "22px",
          bottom: "22px",
          background: open ? "var(--ink)" : "var(--red)",
          boxShadow: open
            ? "0 10px 30px rgba(17,18,24,.35)"
            : "0 10px 30px rgba(217,0,32,.35)",
          padding: open ? 0 : "3px",
        }}
      >
        {open ? (
          <X size={26} />
        ) : (
          <img
            src={`${process.env.PUBLIC_URL}/img/NEXO-PERFIL.jpg`}
            alt="NEXO"
            className="w-full h-full rounded-full object-cover"
          />
        )}
      </button>
    </>
  );
};

export default ChatBubble;
